@if (isLive && phrases.length > 0) {
    <div class="campaign-ticker-bar" role="region" [attr.aria-label]="ariaLabel">
        <div class="campaign-ticker">
            <ng-container *ngTemplateOutlet="half"></ng-container>
            <ng-container *ngTemplateOutlet="half"></ng-container>
        </div>
    </div>
}

<ng-template #half>
    <div class="campaign-ticker-half" aria-hidden="true">
        @for (copy of repeatIndexes; track copy) {
            @for (phrase of phrases; track $index) {
                <span class="campaign-ticker-phrase">
                    {{ phrase }}
                    <span class="campaign-ticker-dot">·</span>
                </span>
            }
        }
    </div>
</ng-template>
